import { useDataValue } from 'Simple/Data.js'

export default function useDataConfiguration(props) {
  let appointment_id = useDataValue({
    viewPath: props.viewPath,
    context: 'appointment_booking',
    path: 'appointment__id',
  })

  return {
    variables: { appointment_id },
    pause: !appointment_id,
  }
}
